import { render, staticRenderFns } from "./CollectionReport_EIBIC.vue?vue&type=template&id=15711f14&"
import script from "./CollectionReport_EIBIC.vue?vue&type=script&lang=js&"
export * from "./CollectionReport_EIBIC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports